<script setup>
import { useRouter } from "vue-router";
import { useTemplateStore } from "@/stores/template";
import { ref, watch } from "vue";
import commonUtils from "@/utils/commonUtils";

defineProps({
  privacyPolicys: {},
});

const router = useRouter();
const templateStore = useTemplateStore();
let equipmentType = ref(templateStore.responsive.equipmentType);
watch(
  () => templateStore.responsive.equipmentType,
  (newValue) => {
    equipmentType.value = newValue;
  }
);
</script>
<template>
  <section
    v-if="
      commonUtils.sortByParams(privacyPolicys, 'sequenceNumber') &&
      commonUtils.sortByParams(privacyPolicys, 'sequenceNumber').length > 0
    "
    id="tour_details_main"
    class="section_padding"
  >
    <div class="container">
      <div v-if="equipmentType !== 'iphone'" class="row">
        <div class="col-lg-3 col-md-3 col-sm-3 col-3">
          <div class="header_back">
            <a @click="router.back">
              <i class="bi bi-arrow-left-square back_icon" size="40"></i>
              <span style="font-size: 27px">{{ $t("back") }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="terms_service_content">
            <div
              v-for="(
                privacyPolicy, privacyPolicyIndex
              ) in commonUtils.sortByParams(privacyPolicys, 'sequenceNumber')"
              :key="privacyPolicyIndex"
              class="terms_item"
            >
              <h4>{{ privacyPolicy.title }}</h4>
              <p v-html="privacyPolicy.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
